"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Scroll {
    /**
     * When the given element has a vertical scrollbar, prevent the mousewheel from scrolling the browser window when
     * the edge of the scrollable element has been reached
     */
    static setScrollLock(element) {
        element.addEventListener('wheel', (evt) => {
            const up = evt.deltaY < 0;
            const scrollTop = element.scrollTop;
            if (up === true && scrollTop === 0) {
                evt.stopPropagation();
                evt.preventDefault();
                return;
            }
            const scrollHeight = element.scrollHeight;
            const height = element.getHeight('outer');
            if (up === false && scrollTop + height >= scrollHeight) {
                evt.stopPropagation();
                evt.preventDefault();
            }
        });
        return element;
    }
}
exports.default = Scroll;
//# sourceMappingURL=Scroll.js.map